export class MessagePriorityReferenceModel {
    messagePriorityCode: string;
    messagePriorityName: string;
}